import { render } from "./Gene_Transcripts.vue?vue&type=template&id=14d3cfe2"
import script from "./Gene_Transcripts.vue?vue&type=script&lang=js"
export * from "./Gene_Transcripts.vue?vue&type=script&lang=js"

import "./Gene_Transcripts.vue?vue&type=style&index=0&id=14d3cfe2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__